import { buildExpandedFine, mapFinePayment, buildClaim, makeClaim } from './converters'
import * as client from 'commons/js/api/client'
import * as api from 'commons/js/api'
import Routes from 'commons/js/routes/routes'

export const NON_CANCELABLE_FINE = 480
export const PARKING_NOT_FOUND = 404

export async function getFine ({ bulletinNumber, townId, brandId }) {
    const url = Routes.apiCheckExpandedFine({ bulletinNumber, townId, brandId })
    const { result, status } = await client.get(url)

    if (status === 'success') {
        return {result: buildExpandedFine(result)}
    }

    return { error: result }
}

export async function payFine (request) {
    const url = Routes.apiPayExpandedFine()
    const { result, status } = await client.post(url, mapFinePayment(request))

    if (status === 'success') {
        return { result }
    }

    return { error: result }
}

export async function reportClaim ({ bulletinNumber, townId, claim, brandId }) {
    const url = Routes.apiReportClaim({ townId })

    const { result, status } = await client.postMultipart(url, buildClaim(claim, townId, bulletinNumber, brandId))

    if (status === 'success') {
        return { result: makeClaim(result) }
    }

    return { error: result }
}

export const createSetupIntent = api.createSetupIntent
